
import { defineComponent } from "vue";
import MenuLateral from "./components/MenuLateral.vue";
import Notificacoes from "./components/Notificacoes.vue";

export default defineComponent({
  name: "App",
  components: { MenuLateral, Notificacoes },
  data() {
    return {
      modoEscuroAtivo: false,
    };
  },
  methods: {
    /**
     * Altera o Estado do toggle Tema ao Clique do User no Botão
     *@description
     *26/07/2022 vlima toggle Tema
     */
    toggleTema(modoEscuroAtivo: boolean) {
      this.modoEscuroAtivo = modoEscuroAtivo;
    },
  },
});
